import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import Creatable from "react-select/creatable";
import api from "api/api";

//Props Validations
// import PropTypes from "prop-types";

//Material UI Components
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

// import mui icons
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloseIcon from "@mui/icons-material/Close";

//import assets
import brandImg from "../../assets/brands.png";
import competitorImg from "../../assets/competitor.png";
import productImg from "../../assets/product.jpg";
import productNameImg from "../../assets/product-name.jpeg";
import sharePointImg from "../../assets/sharepoint.png";
import studyRefImg from "../../assets/study-ref.jpeg";
import uploadImg from "../../assets/upload.jpeg";
import studyTypeImg from "../../assets/study-type.png";
import studyTypeMethodImg from "../../assets/study-type-method.png";

//fake db

//import components
import AlertDialogue from "./AlertDialogue";
import Loader from "../common/Loader";
import SanityCheckDialogue from "./SanityCheckDialogue";

import ReactSelectStyles from "../../styles/ReactSelectStyles";

//redux
import { useSelector } from "react-redux";

const Alert = React.forwardRef(function Alert(props, ref) {
    return (
        <MuiAlert
            elevation={6}
            ref={ref}
            variant="filled"
            {...props}
        />
    );
});

function UploadDataSeeding() {
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const productCategoryOptions = [
        {
            label: productCategoryData?.label || "",
            value: productCategoryData?.value || null,
        },
    ];

    const [data, setData] = useState({
        productCategory: productCategoryOptions[0],
        studyType: null,
        studyTypeMethod: null,
        unileverBrand: [],
        competitorBrand: [],
        // country: null,
        projectName: null,
        // studyPeriod: null,
        sharepointLink: null,
        studyReference: null,
    });

    // dropdowns options variables
    // const [productCategoryOptions, setProductCategoryOptions] = useState([]);
    const [studyTypeOptions, setStudyTypeOptions] = useState([]);
    const [studyTypeMethodOptions, setStudyTypeMethodOptions] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [unileverBrandOptions, setUnileverBrandOptions] = useState([]);
    const [competitorBrandOptions, setCompetitorBrandOptions] = useState([]);

    //variables for dialogue
    const [successDialogueOpen, setSuccessDialogueOpen] = useState(false);
    const [errorDialogueOpen, setErrorDialogueOpen] = useState(false);
    const [sanityCheckDialogOpen, setSanityCheckDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // file details variable
    const [title, setTitle] = useState("");
    const [attachment, setAttachment] = useState(null);

    //loader variables
    const [isLoading, setIsLoading] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("Loading");

    //sanity checks data variables
    const [redSanityChecks, setRedSanityChecks] = useState([]);
    const [yellowSanityChecks, setYellowSanityChecks] = useState([]);

    const [disabledUpload, setDisabledUpload] = useState(true);

    const [newCoreDataId, setNewCoreDataId] = useState(null);

    // snackbar error
    const [snackInfo, setSnackInfo] = useState(["error", "error"]);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    // Image upload dialog variable

    // study type method variables
    const [showDialog, setShowDialog] = useState(false);
    const [studyTypeMethodFormData, setStudyTypeMethodFormData] = useState({ title: "", description: "", template: "" });
    const [disableStudyTypeMethod, setDisableStudyTypeMethod] = useState(true);
    const [disableDownloadTemplate, setDisableDownloadTemplate] = useState(true);

    const transformData = useCallback((data, inputField) => {
        if (inputField === "study_type_method") {
            const objArr = data.map((datum) => {
                const optionLabel = formatDropdownOption(datum.title, datum.study_type__title);
                return {
                    value: datum.id,
                    label: optionLabel,
                    title: datum.title,
                };
            });
            return objArr;
        } else if (inputField === "study_type") {
            const options = data.map((datum) => ({
                value: datum.id,
                label: datum.title,
            }));
            options.sort((a, b) => b.label.localeCompare(a.lable));
            return options;
        } else {
            return data.map((datum) => ({
                value: datum.id,
                label: datum.title,
            }));
        }
    }, []);

    function buildUrl(url, productCategoryId) {
        return productCategoryId ? `${url}?product_category=${productCategoryId}` : url;
    }

    function handleFetchError(error) {
        console.error("Error", error);
    }

    const fetchStudyTypeMethodData = useCallback(async () => {
        if (data.studyType?.value) {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/study-type-methods/all/`;
            const url = buildUrl(baseUrl, productCategoryId) + `&study_type=${data.studyType?.value}`;

            try {
                const res = await api.get(url);
                const data = Array.isArray(res.data) ? res.data : [];
                const options = transformData(data, "study_type_method");
                setStudyTypeMethodOptions(options);
            } catch (error) {
                handleFetchError(error);
            }
        }
    }, [productCategoryId, transformData, data.studyType]);

    useEffect(() => {
        fetchStudyTypeMethodData();
    }, [fetchStudyTypeMethodData]);

    useEffect(() => {
        async function fetchStudyTypeData() {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/study-types/all/`;
            const url = buildUrl(baseUrl, productCategoryId);

            try {
                const res = await api.get(url);
                const data = Array.isArray(res.data) ? res.data : [];
                const options = transformData(data, "study_type");
                setStudyTypeOptions(options);
            } catch (error) {
                handleFetchError(error);
            }
        }

        async function fetchUnileverBrandData() {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/core-data-models/data-driven/unilever-brands/`;
            const url = buildUrl(baseUrl, productCategoryId);

            try {
                const res = await api.get(url);
                const data = Array.isArray(res.data) ? res.data : [];
                const options = transformData(data, "unilever_brand");
                setUnileverBrandOptions(options);
            } catch (error) {
                handleFetchError(error);
            }
        }
        async function fetchCompetitorBrandData() {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/core-data-models/data-driven/competitor-brands/`;
            const url = buildUrl(baseUrl, productCategoryId);

            try {
                const res = await api.get(url);
                const data = Array.isArray(res.data) ? res.data : [];
                const options = transformData(data, "competitor_brand");
                setCompetitorBrandOptions(options);
            } catch (error) {
                handleFetchError(error);
            }
        }
        fetchStudyTypeData();
        fetchUnileverBrandData();
        fetchCompetitorBrandData();
    }, [productCategoryId, transformData]);

    useEffect(() => {
        async function fetchTemplates(studyTypeId) {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/study-type-methods/all/`;
            const url = buildUrl(baseUrl, productCategoryId) + `&study_type=${studyTypeId}`;

            try {
                const res = await api.get(url);
                const templateData = Array.isArray(res.data) ? res.data : [];
                const options = transformData(templateData);
                setTemplates(options);
            } catch (error) {
                handleFetchError(error);
            }
        }

        if (!disableStudyTypeMethod && data.studyType?.value) {
            setData((prevState) => ({
                ...prevState,
                ["studyTypeMethod"]: null,
            }));
            fetchTemplates(data.studyType?.value);
        }
    }, [disableStudyTypeMethod, productCategoryId, data.studyType?.value, transformData]);

    const handleInputChange = useCallback((e, name) => {
        let _newValue = null;
        if (name === "projectName" || name === "studyReference" || name === "sharepointLink") {
            _newValue = e.target.value;
        } else if (name === "studyTypeMethod") {
            const obj = { value: e.value, label: e.title };
            _newValue = obj;
        } else {
            _newValue = e;
        }

        if (name === "studyType" && _newValue) {
            setDisableStudyTypeMethod(false);
        }

        setData((prevState) => ({
            ...prevState,
            [name]: _newValue,
        }));
    }, []);

    const handleCreateNewOptions = async (inputValue, name) => {
        const payload = {
            title: inputValue,
            description: inputValue,
        };

        let url = process.env.REACT_APP_SERVER_PATH;
        if (name === "unileverBrand") {
            url += `/unilever-brands/`;
        } else if (name === "competitorBrand") {
            url += `/competitor-brands/`;
        } else if (name === "studyReference") {
            url += `/study-references/`;
        } else if (name === "studyPeriod") {
            url += `/study-periods/`;
        } else if (name === "projectName") {
            url += `/project-names/`;
        }
        try {
            await api
                .post(url, payload)
                .then(async (res) => {
                    const data = {
                        value: res.data.id,
                        label: res.data.title,
                    };
                    if (name === "unileverBrand") {
                        setUnileverBrandOptions([data, ...unileverBrandOptions]);
                        setData((prevState) => ({
                            ...prevState,
                            [name]: [...prevState[name], data],
                        }));
                    } else if (name === "competitorBrand") {
                        setCompetitorBrandOptions([data, ...competitorBrandOptions]);
                        setData((prevState) => ({
                            ...prevState,
                            [name]: [...prevState[name], data],
                        }));
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    // handleSubmit function refactored to reduce cognitive complexity -- start
    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/`;

        const formData = buildFormData();

        const config = {
            headers: {
                "content-type": "multipart/form-data",
            },
        };

        setLoaderMessage("Uploading");
        setIsLoading(true);

        try {
            const res = await api.post(url, formData, config);
            await handleSuccessResponse(res.data);
        } catch (error) {
            await handleErrorResponse(error);
        } finally {
            handleReset();
            setDisabledUpload(true);
        }
    };

    const buildFormData = () => {
        const formData = new FormData();
        formData.append("attachment", attachment);
        formData.append("title", title);
        formData.append("product_category", data.productCategory?.value || "");
        formData.append("project_name_title", data.projectName || "");
        formData.append("study_reference_title", data.studyReference || "");
        formData.append("share_point_link", data.sharepointLink || "");
        formData.append("study_type", data.studyType?.value || "");
        formData.append("study_type_method", data.studyTypeMethod?.value);

        data.unileverBrand?.forEach((item) => {
            formData.append("unilever_brands", item.value);
        });

        data.competitorBrand?.forEach((item) => {
            formData.append("competitor_brands", item.value);
        });

        return formData;
    };

    const handleSuccessResponse = async (data) => {
        setIsLoading(false);

        const hasRed = data.red?.length > 0;
        const hasYellow = data.yellow?.length > 0;

        if (hasRed) setRedSanityChecks(data.red);
        if (hasYellow) setYellowSanityChecks(data.yellow);

        if (hasRed && hasYellow) {
            setErrorMessage("Oh No! Validation Failed!");
            setErrorDialogueOpen(true);
        } else {
            setSuccessDialogueOpen(true);
        }

        try {
            await api.get(`${process.env.REACT_APP_SERVER_PATH}/crons/run/`);
        } catch (error) {
            console.error("Error", error);
        }
    };

    const handleErrorResponse = async (error) => {
        setIsLoading(false);
        console.error("Error", error);

        const err = error?.response?.data;

        if (err?.error) {
            if (err.error.red) setRedSanityChecks(err.error.red);
            if (err.error.yellow) setYellowSanityChecks(err.error.yellow);
            if (err.error.core_data_id?.length) setNewCoreDataId(err.error.core_data_id[0]);

            setErrorMessage("Oh No! Validation Failed!");
            setErrorDialogueOpen(true);
            return;
        }

        if (err?.attachment) {
            showSnackError(err.attachment.join(" "));
            return;
        }

        if (err?.title) {
            showSnackError(err.title.join(" "));
            return;
        }

        showSnackError(error.message);
        setTitle("");
        setAttachment(null);
    };

    const showSnackError = (message) => {
        setSnackInfo(["error", message]);
        setSnackBarOpen(true);
    };

    // handleSubmit function refactored to reduce cognitive complexity -- end

    const handleReset = () => {
        setData({
            ...data,
            // productCategory: null,
            unileverBrand: [],
            competitorBrand: [],
            // country: null,
            projectName: "",
            // studyPeriod: null,
            sharepointLink: "",
            studyReference: "",
            studyType: null,
            studyTypeMethod: null,
        });
        setTitle("");
        setAttachment(null);
    };

    const handleSuccessClose = () => {
        setSuccessDialogueOpen(false);
    };

    const handleErrorClose = () => {
        handleSanityCheckDialogueGoBackButtonClick();
        setErrorDialogueOpen(false);
    };

    const handleSnackBarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackBarOpen(false);
    };

    const handleSanityCheckDialogueGoBackButtonClick = async () => {
        const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/new/${newCoreDataId}/`;
        const payload = {
            seeding_log: "Upload:User:Go Back",
        };
        try {
            await api
                .patch(url, payload)
                .then(async () => {})
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    // handleSanityCheckDialogueUpdateButtonClick fuction refactored to reduce cognitive complexity -- start

    const handleSanityCheckDialogueUpdateButtonClick = async () => {
        const url = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/new/${newCoreDataId}/`;
        const payload = {
            parsed: false,
            archive: false,
            seeding_log: "Upload:User:Validation Failed,Proceded by User",
        };

        setIsLoading(true);

        try {
            const res = await api.patch(url, payload);
            handleSanitySuccessResponse(res.data);
        } catch (error) {
            handleSanityErrorResponse(error);
        } finally {
            setIsLoading(false);
            setSanityCheckDialogOpen(false);
        }
    };

    const handleSanitySuccessResponse = async (data) => {
        if (data?.red?.length) setRedSanityChecks([...data.red]);
        if (data?.yellow?.length) setYellowSanityChecks([...data.yellow]);

        const redExists = data?.red?.length;
        const yellowExists = data?.yellow?.length;

        if (redExists && yellowExists) {
            setErrorMessage("Oh No! Validation Failed!");
            setErrorDialogueOpen(true);
        } else {
            setSuccessDialogueOpen(true);
            setErrorDialogueOpen(false);
        }

        setSanityCheckDialogOpen(false);
        handleReset();

        try {
            await api.get(`${process.env.REACT_APP_SERVER_PATH}/crons/run/`);
        } catch (err) {
            console.error("error", err);
        }
    };

    const handleSanityErrorResponse = (error) => {
        const errData = error?.response?.data || {};

        if (errData.error) {
            if (errData.error?.red) setRedSanityChecks([...errData.error.red]);
            if (errData.error?.yellow) setYellowSanityChecks([...errData.error.yellow]);
            if (errData.error?.core_data_id?.length) {
                setNewCoreDataId(errData.error.core_data_id[0]);
            }
            setErrorMessage("Oh No! Validation Failed!");
            setErrorDialogueOpen(true);
            return;
        }

        if (errData.attachment) {
            const str = errData.attachment.join(" ");
            setSnackInfo(["error", str]);
            setSnackBarOpen(true);
        } else if (errData.title) {
            const str = errData.title.join(" ");
            setSnackInfo(["error", str]);
            setSnackBarOpen(true);
        } else {
            setSnackInfo(["error", error.message]);
            setSnackBarOpen(true);
        }
    };

    // handleSanityCheckDialogueUpdateButtonClick fuction refactored to reduce cognitive complexity -- end

    const handleSanityCheckDialogue = () => {
        setSanityCheckDialogOpen(!sanityCheckDialogOpen);
    };

    const changeHandler = (e) => {
        if (e.target.files?.[0]) {
            setAttachment(e.target.files[0]);
            setTitle(e.target.files[0].name);
        }
    };

    useEffect(() => {
        const flag = Object.keys(data).every((key) => {
            const value = data[key];

            // Check if the value is an array and ensure it has elements
            if (Array.isArray(value)) {
                return value.length > 0;
            }

            // Check if the value is an object and ensure it has any keys
            if (typeof value === "object" && value !== null) {
                return Object.keys(value).length > 0;
            }

            // Check for truthy values (string, number, etc.)
            return Boolean(value);
        });

        if (typeof data.studyType === "object" && data.studyType !== null && typeof data.studyTypeMethod === "object" && data.studyTypeMethod !== null) {
            setDisableDownloadTemplate(false);
        } else {
            setDisableDownloadTemplate(true);
        }

        if (flag && attachment && title) {
            setDisabledUpload(false);
        } else {
            setDisabledUpload(true);
        }
    }, [data, attachment, title]);

    const formatDropdownOption = (title, studyTypeTitle) => {
        if (studyTypeTitle) {
            const textColor = studyTypeTitle.toLowerCase() === "home use test" ? "#005eef" : "#4CAF50";
            return (
                <div>
                    <span>{title}</span>
                    <span style={{ color: textColor }}>{` (${studyTypeTitle})`}</span>
                </div>
            );
        } else {
            return (
                <div>
                    <span>{title}</span>
                </div>
            );
        }
    };

    const handleCreateStudyTypeMethod = (inputValue) => {
        setStudyTypeMethodFormData({ title: inputValue, description: "", template: "" });
        setShowDialog(true); // open dialog
    };

    const handleCloseStudyTypeMethod = () => {
        setStudyTypeMethodFormData({ title: "", description: "", template: "" });
        setShowDialog(false);
    };

    const handleInputChangeStudyTypeMethod = useCallback((e, name) => {
        let _newValue = null;
        if (name === "template") {
            _newValue = e;
        } else {
            _newValue = e.target.value;
        }
        setStudyTypeMethodFormData((prevState) => ({
            ...prevState,
            [name]: _newValue,
        }));
    }, []);

    const handleSubmitStudyTypeMethod = async () => {
        const payload = {
            title: studyTypeMethodFormData?.title,
            description: studyTypeMethodFormData?.description,
            immediate_parent_method: studyTypeMethodFormData?.template?.value,
            study_type: data.studyType?.value,
            product_category: productCategoryId,
        };

        const url = process.env.REACT_APP_SERVER_PATH + `/study-type-methods/`;
        try {
            await api
                .post(url, payload)
                .then(async (res) => {
                    const studyTypeMethodData = {
                        value: res.data.id,
                        label: res.data.title,
                    };
                    const optionLabel = formatDropdownOption(res.data.title, res.data.study_type_title);
                    const data = {
                        value: res.data.id,
                        label: optionLabel,
                        title: res.data.title,
                    };
                    setStudyTypeMethodOptions([data, ...studyTypeMethodOptions]);
                    setData((prevState) => ({
                        ...prevState,
                        studyTypeMethod: studyTypeMethodData,
                    }));
                    setShowDialog(false);
                })
                .catch((error) => {
                    showSnackError(error.message);
                });
        } catch (error) {
            showSnackError(error.message);
        }
        setShowDialog(false);
    };

    return (
        <>
            {isLoading && <Loader message={loaderMessage} />}
            <div>
                <form onSubmit={handleSubmit}>
                    <div className="row justify-content-md-center mt-0 mb-0 row-cols-5">
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={productImg}
                                        alt={"Product"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Select
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        value={data.productCategory}
                                        placeholder={"Product Category"}
                                        options={productCategoryOptions}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyTypeImg}
                                        alt={"Study Type"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Select
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        onChange={(newValue) => handleInputChange(newValue, "studyType")}
                                        value={data.studyType}
                                        placeholder={"Study Type"}
                                        options={studyTypeOptions}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyTypeMethodImg}
                                        alt={"Study Type Method"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    {disableStudyTypeMethod ? (
                                        <Select
                                            styles={ReactSelectStyles}
                                            className="dropdown dropdown-first-row"
                                            onChange={(newValue) => handleInputChange(newValue, "studyTypeMethod")}
                                            value={data.studyTypeMethod}
                                            isMulti={false}
                                            placeholder={"Study Type Method"}
                                            options={studyTypeMethodOptions}
                                        />
                                    ) : (
                                        <Creatable
                                            styles={ReactSelectStyles}
                                            className="dropdown dropdown-first-row"
                                            closeMenuOnSelect={true}
                                            placeholder={"Study Type Method"}
                                            isSearchable={true}
                                            isMulti={false}
                                            options={studyTypeMethodOptions}
                                            onCreateOption={(newValue) => handleCreateStudyTypeMethod(newValue)}
                                            value={data.studyTypeMethod}
                                            onChange={(newValue) => handleInputChange(newValue, "studyTypeMethod")}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={brandImg}
                                        alt={"Unilever Brand"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Creatable
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        closeMenuOnSelect={false}
                                        placeholder={"Unilever Brand"}
                                        isSearchable={true}
                                        isMulti={true}
                                        options={unileverBrandOptions}
                                        onCreateOption={(newValue) => handleCreateNewOptions(newValue, "unileverBrand")}
                                        value={data.unileverBrand}
                                        onChange={(newValue) => handleInputChange(newValue, "unileverBrand")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={competitorImg}
                                        alt={"Benchmark Brand"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Creatable
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        closeMenuOnSelect={false}
                                        placeholder={"Benchmark Brand"}
                                        isSearchable={true}
                                        isMulti={true}
                                        options={competitorBrandOptions}
                                        onCreateOption={(newValue) => handleCreateNewOptions(newValue, "competitorBrand")}
                                        value={data.competitorBrand}
                                        onChange={(newValue) => handleInputChange(newValue, "competitorBrand")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ marginTop: 30 }}
                        className="row justify-content-md-center mb-0 row-cols-5"
                    >
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={productNameImg}
                                        alt={"Product Name"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container">
                                    <input
                                        type="text"
                                        name="text"
                                        className="text-input"
                                        placeholder="Project Name"
                                        maxLength={100}
                                        value={data.projectName}
                                        onChange={(e) => handleInputChange(e, "projectName")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyRefImg}
                                        alt={"Study Reference"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <input
                                        type="text"
                                        name="studyReference"
                                        className="text-input"
                                        placeholder="Study Reference"
                                        maxLength={100}
                                        value={data.studyReference}
                                        onChange={(e) => handleInputChange(e, "studyReference")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={uploadImg}
                                        alt={"Upload Download"}
                                    />
                                </div>

                                <div className="dropdown-card-dropdown-container card-btns">
                                    <div className="custom-file pmd-custom-file-outline">
                                        <input
                                            onChange={changeHandler}
                                            type="file"
                                            accept=".xlsx"
                                            className="custom-file-input"
                                            id="customOutlineFile"
                                        />
                                        <label className="custom-file-label">{title === "" ? "Choose File" : title}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={sharePointImg}
                                        alt={"SharePoint Link"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <input
                                        type="text"
                                        name="sharepointLink"
                                        className="text-input"
                                        placeholder="SharePoint Link"
                                        value={data.sharepointLink}
                                        onChange={(e) => handleInputChange(e, "sharepointLink")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ marginTop: 20 }}
                        className="custom-btn-container custom-btn-center-container mb-0"
                    >
                        <Button
                            style={{
                                width: 185,
                            }}
                            size="small"
                            type="submit"
                            className={disabledUpload ? "custom-btn custom-btn--upload-reset box-shadow--3" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                            variant="contained"
                            disabled={disabledUpload}
                        >
                            Upload
                        </Button>
                        <Button
                            style={{
                                width: 185,
                            }}
                            size="small"
                            type="reset"
                            className="custom-btn liner-light-blue-background custom-btn--upload-reset"
                            variant="contained"
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                        <Button
                            size="small"
                            style={{
                                textAlign: "left",
                            }}
                            className="custom-btn color-blue custom-btn--upload-reset"
                            endIcon={<CloudDownloadIcon />}
                            variant="outlined"
                            disabled={disableDownloadTemplate}
                            onClick={() => {
                                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/download-template/`;
                                if (productCategoryId) {
                                    url += `?product_category=${productCategoryId}`;
                                }
                                if (data.studyTypeMethod?.value) {
                                    url += `&study_type_method=${data.studyTypeMethod?.value}`;
                                }
                                window.open(url, "_blank");
                            }}
                        >
                            Download Template
                        </Button>
                    </div>
                </form>
            </div>
            {showDialog && (
                <Dialog
                    open={showDialog}
                    onClose={handleCloseStudyTypeMethod}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        id="dialog-title"
                    >
                        Add Study Type Method
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 2,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleCloseStudyTypeMethod}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{ py: 2, px: 4 }}>
                        <div className="stm-form-group">
                            <label htmlFor="title">Study Type Method Title:</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                value={studyTypeMethodFormData?.title}
                                onChange={(e) => handleInputChangeStudyTypeMethod(e, "title")}
                            />
                        </div>
                        <div className="stm-form-group">
                            <label htmlFor="description">Description:</label>
                            <input
                                type="text"
                                id="description"
                                name="description"
                                value={studyTypeMethodFormData?.description}
                                onChange={(e) => handleInputChangeStudyTypeMethod(e, "description")}
                            />
                        </div>
                        <div className="stm-form-group">
                            <label htmlFor="template">Template:</label>
                            <div
                                style={{
                                    display: "inline-block",
                                    width: "66%",
                                    marginLeft: "10px",
                                }}
                            >
                                <Select
                                    styles={ReactSelectStyles}
                                    id="template"
                                    onChange={(newValue) => handleInputChangeStudyTypeMethod(newValue, "template")}
                                    value={studyTypeMethodFormData?.template}
                                    placeholder={"Template"}
                                    options={templates}
                                />
                            </div>
                        </div>
                        <div style={{ justifyContent: "center", display: "flex", marginTop: 20 }}>
                            <Button
                                variant="outlined"
                                className="custom-btn custom-btn--upload-reset"
                                onClick={handleCloseStudyTypeMethod}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="custom-btn custom-btn--upload-reset"
                                onClick={handleSubmitStudyTypeMethod}
                            >
                                Add
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            )}
            <AlertDialogue
                open={successDialogueOpen}
                icon="success"
                title="Success!"
                description="Your file has been uploaded successfully! &nbsp; Data seeding process has been triggered. It will take 30 minutes to reflect the data within the application."
                buttons={
                    <div>
                        <Button
                            size="small"
                            onClick={handleSuccessClose}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            Continue
                        </Button>
                    </div>
                }
            />
            <AlertDialogue
                open={errorDialogueOpen}
                icon="error"
                title="Error!"
                description={errorMessage}
                buttons={
                    <div>
                        <Button
                            size="small"
                            onClick={handleErrorClose}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            Go Back
                        </Button>
                        <Button
                            onClick={handleSanityCheckDialogue}
                            size="small"
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                                marginLeft: 10,
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            View Details
                        </Button>
                    </div>
                }
            />
            <SanityCheckDialogue
                open={sanityCheckDialogOpen}
                errors={[...redSanityChecks]}
                warnings={[...yellowSanityChecks]}
                errorMessage="Please resolve errors before moving ahead"
                title="Sanity Check"
                submitButton="Update"
                closeButton="Cancel"
                handleSubmit={handleSanityCheckDialogueUpdateButtonClick}
                handleClose={handleSanityCheckDialogue}
            />
            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={snackBarOpen}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}
            >
                <Alert
                    onClose={handleSnackBarClose}
                    severity={snackInfo[0]}
                    sx={{
                        maxHeight: 300,
                        maxWidth: 700,
                        width: "100%",
                        overflow: "auto",
                    }}
                >
                    {snackInfo[1]}
                </Alert>
            </Snackbar>
        </>
    );
}

export default UploadDataSeeding;
